<header
  class="sticky top-0 z-50 flex w-full items-center justify-between border-b border-white/10 bg-surface/80 px-container-padding-mobile py-4 backdrop-blur-xl"
>
  <div class="flex items-center gap-3">
    <span
      class="material-symbols-outlined cursor-pointer text-primary transition-transform duration-200 hover:scale-110"
      >games</span
    >
    <h1 class="font-display-xl-mobile text-display-xl-mobile neon-glow-pink text-primary">
      {{ title() }}
    </h1>
  </div>
  <button
    type="button"
    class="material-symbols-outlined cursor-pointer text-on-surface-variant transition-transform duration-200 hover:scale-110 active:scale-95"
    [attr.aria-label]="isSoundEnabled() ? 'Desativar som' : 'Ativar som'"
    (click)="onToggleSound()"
  >{{ isSoundEnabled() ? 'volume_up' : 'volume_off' }}</button>
</header>
